"use strict";
// Copyright 2018-2020 Cruise LLC
// Copyright 2021 Foxglove Technologies Inc
//
// This source code is licensed under the Apache License, Version 2.0,
// found in the LICENSE file in the root directory of this source tree.
// You may not use this file except in compliance with the License.
Object.defineProperty(exports, "__esModule", { value: true });
// browser reader for Blob|File objects
class BlobReader {
    constructor(blob) {
        if (!(blob instanceof Blob)) {
            throw new Error("Expected file to be a File or Blob.");
        }
        this._blob = blob;
        this._size = blob.size;
    }
    // read length (bytes) starting from offset (bytes)
    async read(offset, length) {
        const arrBuf = await this._blob.slice(offset, offset + length).arrayBuffer();
        return new Uint8Array(arrBuf);
    }
    // return the size of the file
    size() {
        return this._size;
    }
}
exports.default = BlobReader;
//# sourceMappingURL=BlobReader.js.map